import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { PesquisaSatisfacaoDropDown } from "../../../../domain/models/pesquisa_satisfacao_dropdown";
import { CreatePesquisaSatisfacaoClienteForm, CreatePesquisaSatisfacaoClienteSchema } from "../../../schemas/SatisfacaoClientePesquisa_lista/create_pesquisa_satisfacao_cliente";
import { zodResolver } from "@hookform/resolvers/zod";

import FormContainer from "../../../../../../common/components/form_container";
import { useEffect } from "react";

/**
 * CreatePesquisaSatisfacaoClienteModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  pesquisaSatisfacaoDropdown: PesquisaSatisfacaoDropDown[];
  onClose: () => void;
  onSubmit: (form: any) => void;
}

export const CreatePesquisaSatisfacaoClienteModal = ({
  open,
  saving,
  loading,
  pesquisaSatisfacaoDropdown,
  onClose,
  onSubmit,
}: Props) => {

  const hookForm = useForm<CreatePesquisaSatisfacaoClienteForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(CreatePesquisaSatisfacaoClienteSchema),
  });

  useEffect(() => {
    if (open) hookForm.reset();
  }, [
    open,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Pesquisa de Satisfação do Cliente"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title="Informações" arrangement="fullRow">
        <>
          <DefaultFormMultiAutocomplete
            name='pesquisaSatisfacao'
            label='Selecione a Pesquisa'
            required={true}
            options={pesquisaSatisfacaoDropdown}
            getOptionKey={x => x.idPesquisaSatisfacao}
            getOptionLabel={x => x.descricao}
            reactHookForm={hookForm}
          />
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}